import { APP_INITIALIZER } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
import { provideRouter, withComponentInputBinding } from '@angular/router';
import { provideIonicAngular } from '@ionic/angular/standalone';
import { addIcons } from 'ionicons';
import {
  add,
  arrowBack,
  bagHandleOutline,
  barcodeOutline,
  cameraOutline,
  cardOutline,
  cashOutline,
  checkmarkCircleOutline,
  close,
  cogOutline,
  constructOutline,
  documentAttachOutline,
  gridOutline,
  homeOutline,
  listOutline,
  logOutOutline,
  remove,
  receiptOutline,
  refresh,
  searchOutline,
  storefrontOutline,
  swapHorizontalOutline,
  trashOutline,
} from 'ionicons/icons';
import { AppComponent } from './app/app.component';
import { routes } from './app/app.routes';
import { PosStoreService } from '@adminpages/pos-state';

function initializePosSession(store: PosStoreService): () => Promise<void> {
  return async () => {
    store.applyTheme();
    await store.ensureSession();
  };
}

addIcons({
  add,
  arrowBack,
  bagHandleOutline,
  barcodeOutline,
  cameraOutline,
  cardOutline,
  cashOutline,
  checkmarkCircleOutline,
  close,
  cogOutline,
  constructOutline,
  documentAttachOutline,
  gridOutline,
  homeOutline,
  listOutline,
  logOutOutline,
  remove,
  receiptOutline,
  refresh,
  searchOutline,
  storefrontOutline,
  swapHorizontalOutline,
  trashOutline,
});

bootstrapApplication(AppComponent, {
  providers: [
    provideAnimations(),
    provideHttpClient(),
    provideIonicAngular(),
    provideRouter(routes, withComponentInputBinding()),
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [PosStoreService],
      useFactory: initializePosSession,
    },
  ],
}).catch((error) => console.error(error));
